import { FC } from "react";

import { VStack, HStack, useMultiStyleConfig, SystemStyleObject, SystemProps } from "@chakra-ui/react";

const FormBox: FC<{ children?: any; isGrey?: boolean; inline?: boolean; sx?: SystemStyleObject; spacing?: SystemProps["margin"] }> = ({
  children,
  isGrey,
  inline,
  sx,
  spacing,
}) => {
  const Component = inline ? HStack : VStack;
  const styles = useMultiStyleConfig("Common", {});
  return (
    <Component sx={{ ...(isGrey ? styles.formGreyBox : styles.formBox), ...sx }} spacing={spacing}>
      {children}
    </Component>
  );
};

export default FormBox;
